import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { EncryptionService } from './encryption.service';
import { AppEnum } from '../appenum';

@Injectable({
  providedIn: 'root',
})
export class AppNavigation {

  constructor(
    private nav: NavController,
    private router: Router,
    private encryptionService: EncryptionService,
    private appEnum: AppEnum
  ) { }

  // private getTaskId(): string {
  //   try {
  //     return this.encryptionService.decrypt(
  //       this.encryptionService.localstorageDecrypt(
  //         this.appEnum.EntityOfLocalStorageKeys.taskId
  //       )
  //     ) || '';
  //   } catch {
  //     return '';
  //   }
  // }

  private getTaskId(): string {
    try {
      const stored = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this.appEnum.EntityOfLocalStorageKeys.taskId
        )
      );
      if (stored) {
        return stored;
      }
    } catch {
      // ignore decrypt/localStorage errors and fall through to the URL param
    }
    return new URLSearchParams(window.location.search).get('taskId') || '';
  }

  private buildExtras(extras?: NavigationExtras): NavigationExtras {
    const taskId = this.getTaskId();
    return {
      ...extras,
      queryParams: {
        taskId: taskId,
        ...extras?.queryParams
      }
    };
  }

  navigateForward(path: string | string[], extras?: NavigationExtras): void {
    this.nav.navigateForward(path, this.buildExtras(extras));
  }

  navigateBack(path: string | string[], extras?: NavigationExtras): void {
    this.nav.navigateBack(path, this.buildExtras(extras));
  }
  navigate(path: string[], extras?: NavigationExtras): void {
    this.router.navigate(path, this.buildExtras(extras));
  }

  navigateRoot(path: string | any[], extras?: NavigationExtras): void {
    const { cleanPath, routeParams } = this.extractRouteParams(path);
    const builtExtras = this.buildExtras(extras);
    if (Object.keys(routeParams).length > 0) {
      this.nav.navigateRoot([...cleanPath, routeParams], builtExtras);
    } else {
      this.nav.navigateRoot(cleanPath, builtExtras);
    }
  }

  private extractRouteParams(path: string | any[]): { cleanPath: string[], routeParams: object } {
    if (typeof path === 'string') {
      return { cleanPath: [path], routeParams: {} };
    }
    const cleanPath = path.filter(segment => typeof segment === 'string');
    const routeParams = path.find(segment => typeof segment === 'object') || {};

    return { cleanPath, routeParams };
  }
}
